import styled from 'styled-components';
import {
    primaryColorLight, green, primaryColorDark
} from '../../../config/colors';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  table {
    width: 100%;
    border-spacing: 0;

    th,
    td {
      padding: 0.5rem;
    }

    thead {
      tr {
        th {
          font-weight: 500;
          opacity: 0.8;
          padding-bottom: 1rem;
          :first-of-type {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
    }

    tbody {
      tr {
        td {
          text-align: center;
          border: 1px solid white;
          :first-of-type {
            background-color: transparent;
            border: 0;
          }
        }
        :first-of-type td {
          border-top: 0;
        }
      }
      .historyItem {
        td {
          background-color: #eee;
        }
      }
    }
  }
`;

export const ProjectIdCardLink = styled.div`
  cursor: pointer;
  color: white;
  padding: 0.3em;
  background-color: ${primaryColorLight};
  border-radius: 0.5em;
  border: 2px solid white;
  :hover {
    font-weight: bold;
  }
`;

export const CreateIdCardLink = styled.div`
  min-width:70px;
  cursor: pointer;
  color: white;
  padding: 0.3em;
  background-color: ${green};
  border-radius: 0.5em;
  border: 2px solid white;
  :hover {
    font-weight: bold;
  }
`;
